import React from 'react';
import { useStoreState, useStoreActions } from '../../models/hooks';
import { TodoSummary } from './TodoSummary';

export const DashboardTodoSummary = (): JSX.Element | null => {
  const { openTodoSummary, filterByStatus } = useStoreState((state) => state.todo);
  const { setFilterByStatus } = useStoreActions((actions) => actions.todo);

  if (!openTodoSummary) {
    return null;
  }

  return <TodoSummary filterByStatus={filterByStatus} setFilterByStatus={setFilterByStatus} />;
};
